import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { InternalApiCustomList, InternalApiCustomListRecord } from '../../api-internal';
import { CustomListRecordStatusLabel } from './CustomListRecordStatusLabel';

interface Props {
  customList: InternalApiCustomList | undefined;
  record: InternalApiCustomListRecord | undefined;
}

export const CustomListRecordHeaderSubTitle = ({ customList, record }: Props) => {
  const isNew = !record;
  const isActive = !record?.endTime;
  return (
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
      <Link
        className='text-m'
        to={isNew || isActive ? `/custom-lists/${customList?.id}` : `/custom-lists/${customList?.id}?showArchived=true`}
      >
        {isNew || isActive ? customList?.name : `Archived records for ${customList?.name}`}
      </Link>
      {record && (
        <>
          <FontAwesomeIcon icon={faArrowRight} style={{ color: 'var(--secondary-default)' }} />
          <span>{record.id}</span>
          <CustomListRecordStatusLabel status={record.status} />
        </>
      )}
    </div>
  );
};
